(function($) {
    "use strict";
    // Functions
    let data_function = {
        accept_job_offers: function(product_id){
            let nonce = jQuery("#_wpnonce").val();
            jQuery(".ets-job-accept-error").html("");

            $.ajax({
                url: etsJobOffersJs.ajaxurl,
                type: 'POST',
                data: {
                    action : "ets_accept_job_offers",
                    product_id : product_id,
                    _nounce: nonce
                },
                dataType:"JSON",
                success: function(data) {
                    $('.ets-job-accepted').prop('disabled', false);
                    if (data.status) {
                        if (data.redirect_url)
                        location.href = data.redirect_url;
                        //else location.reload(true);
                    } else jQuery(".ets-job-accept-error").html(data.msg);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $('.ets-job-accepted').prop('disabled', false);
;
                    $(".ets-job-accept-loder").css("display", "none");
                    alert(xhr.status + " : "+thrownError);
                }
            });
        }
    }
    // Action Calls
    $(document).ready(function() {
        if(jQuery(".ets-job-rejected").length > 0) {
            jQuery(".ets-job-rejected").on("click", function(e){
                e.preventDefault();
                jQuery(".ets-job-reject-reason").css("display", "inline-block");
            });
        }

        jQuery(".ets-job-accepted").on("click", function(e){
            e.preventDefault();
            let product_id = jQuery(".ets-job-accepted").data('prd_id');
            $('.ets-job-accepted').prop('disabled', true);
;
            $(".ets-job-accept-loder").css("display", "inline-block");
            
            data_function.accept_job_offers(product_id);
        });
    });
})(jQuery);